import axios from 'axios';
import { GET_ALL_EVENTS } from './actionTypes';
import { Constants } from '../../constants';

// eslint-disable-next-line import/prefer-default-export
export const getAllEvents = (page, limit, query) => (dispatch) => {
  axios
    .get(`${Constants.apiPath}/events/datatables/all`, {
      params: {
        page,
        limit,
        q: query,
      },
    })
    .then((res) => {
      dispatch({
        type: GET_ALL_EVENTS,
        payload: {
          data: res.data.data,
          totalSize: res.data.recordsFiltered,
        },
      });
    })
    .catch((e) => {
      console.log(e.message);
    });
};
